import React from 'react';

interface BadgeProps {
    variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info';
    children: React.ReactNode;
    className?: string;
}

const Badge: React.FC<BadgeProps> = ({
                                         variant = 'primary',
                                         children,
                                         className = '',
                                     }) => {
    const baseClasses = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';

    const variantClasses = {
        primary: 'bg-blue-100 text-blue-800',
        secondary: 'bg-gray-100 text-gray-800',
        success: 'bg-green-100 text-green-800',
        danger: 'bg-red-100 text-red-800',
        warning: 'bg-yellow-100 text-yellow-800',
        info: 'bg-indigo-100 text-indigo-800',
    };

    const classes = `${baseClasses} ${variantClasses[variant]} ${className}`;

    return <span className={classes}>{children}</span>;
};

export default Badge;